export const ADD_SUCCESS = 'Новый тариф добавлен';
export const ADD_ERROR = 'Не удалось добавить тариф';
